export const creatept =`
mutation CreatePT($months: [MonthInput!]!, $slabs: [SlabInput!]!) {
  createPtConfig(months: $months, slabs: $slabs) {
    success
    message
  }
}
`

export const updatept =`

mutation UpdatePT($months: [MonthInput!]!, $slabs: [SlabInput!]!) {
  updatePtConfig(months: $months, slabs: $slabs) {
    success
    message
  }
}
`

export const getallpt =`
query getAllPtConfig{
  getAllPtConfig {
    months {
      startMonth
      endMonth
    }
    slabs {
      salaryFrom
      salaryTo
      ptAmount
    }
  }
}

`

export const deletept =`
mutation deletePTConfig{
  deletePtConfig{
    success
    message
  }
}
`